export const FETCH_FEATURED_AD_REQUEST = 'FETCH_FEATURED_AD_REQUEST';
export const RESET_FEATURED_AD = 'RESET_FEATURED_AD';
export const FETCH_FEATURED_AD_START = 'FETCH_FEATURED_AD_START';
export const FETCH_FEATURED_AD_SUCCESS = 'FETCH_FEATURED_AD_SUCCESS';
export const FETCH_FEATURED_AD_FAILED = 'FETCH_FEATURED_AD_FAILED';



// WEBPACK FOOTER //
// ./app/FeaturedAd/constants.js